import React, { useState } from "react";
import { useWeather } from "../context/WeatherContext";

const WeatherWidget = ({ defaultCity }) => {
  const { city, weather, forecast, loading, error, changeCity } = useWeather();
  const [cityInput, setCityInput] = useState("");
  const [editing, setEditing] = useState(false);

  const handleEdit = () => {
    setEditing(true);
    setCityInput(weather?.city || city);
  };

  const handleSave = (e) => {
    e.preventDefault();
    changeCity(cityInput);
    setEditing(false);
  };

  if (loading) {
    return (
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 flex justify-center items-center h-48">
        <div className="animate-spin rounded-full h-8 w-8 border-4 border-purple-600 border-t-transparent"></div>
      </div>
    );
  }

  if (error && !weather) {
    return (
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 text-center h-48 flex flex-col items-center justify-center gap-2">
        <i className="fa-solid fa-cloud-rain text-3xl text-gray-400"></i>
        <p className="text-sm text-gray-600">{error}</p>
        <div className="flex items-center gap-2">
          <button
            onClick={() => changeCity(city)}
            className="text-xs font-bold text-brand-red hover:underline"
          >
            पुनः प्रयास करें
          </button>
          <span className="text-gray-300">|</span>
          <button
            onClick={handleEdit}
            className="text-xs font-bold text-brand-red hover:underline"
          >
            स्थान बदलें
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-br from-blue-500 to-blue-700 rounded-2xl shadow-md overflow-hidden text-white relative">
      <div className="absolute top-0 right-0 -mr-8 -mt-8 w-32 h-32 rounded-full bg-white opacity-10"></div>
      <div className="absolute bottom-0 left-0 -ml-8 -mb-8 w-24 h-24 rounded-full bg-white opacity-10"></div>

      <div className="p-4 relative z-10">
        <div className="flex justify-between items-start mb-3">
          <div>
            <h3 className="font-bold text-base flex items-center gap-2">
              <i className="fa-solid fa-location-dot text-purple-400"></i>
              {editing ? (
                <form onSubmit={handleSave} className="flex items-center gap-1">
                  <input
                    autoFocus
                    value={cityInput}
                    onChange={(e) => setCityInput(e.target.value)}
                    placeholder="शहर का नाम"
                    className="w-32 text-xs font-normal text-gray-900 px-2 py-1 rounded outline-none"
                  />
                  <button type="submit" className="text-xs text-white hover:text-purple-300" title="सेव करें">
                    <i className="fa-solid fa-check"></i>
                  </button>
                  <button type="button" onClick={() => setEditing(false)} className="text-xs text-white hover:text-purple-300" title="रद्द करें">
                    <i className="fa-solid fa-xmark"></i>
                  </button>
                </form>
              ) : (
                weather?.city
              )}
            </h3>
            <p className="text-blue-100 text-[10px] mt-0.5">आज का मौसम</p>
          </div>
          <button
            onClick={handleEdit}
            className="bg-white/20 hover:bg-white/30 transition-colors text-xs font-semibold px-2.5 py-1.5 rounded-lg flex items-center gap-1.5"
            title="स्थान बदलें"
          >
            <i className="fa-solid fa-location-arrow"></i>
            <span>स्थान बदलें</span>
          </button>
        </div>

        <div className="flex items-center justify-between my-4">
          <div className="flex items-center gap-3">
            <i className={`fa-solid ${weather.icon} text-4xl text-brand-red drop-shadow-md animate-pulse`}></i>
            <div>
              <div className="text-3xl font-black leading-none">{weather.temp}°C</div>
              <div className="text-xs font-medium text-blue-100 uppercase tracking-wider mt-1">{weather.condition}</div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2 border-t border-blue-400/30 pt-3 mt-1">
          <div className="flex items-center gap-1.5 text-xs text-blue-100">
            <i className="fa-solid fa-droplet text-blue-300"></i>
            <span>{weather.humidity}</span>
          </div>
          <div className="flex items-center gap-1.5 text-xs text-blue-100">
            <i className="fa-solid fa-wind text-blue-300"></i>
            <span>{weather.wind}</span>
          </div>
        </div>
      </div>

      {forecast.length > 0 && (
        <div className="bg-brand-red/20 p-3 backdrop-blur-sm relative z-10">
          <h4 className="text-[10px] uppercase tracking-widest text-blue-200 mb-2 font-semibold text-center">3 दिन का पूर्वानुमान</h4>
          <div className="flex justify-between px-2">
            {forecast.map((item, index) => (
              <div key={index} className="flex flex-col items-center text-xs">
                <span className="text-blue-100 mb-0.5 text-[10px]">{item.day}</span>
                <i className={`fa-solid ${item.icon} text-base mb-1 ${item.icon.includes('sun') ? 'text-brand-red' : 'text-gray-300'}`}></i>
                <span className="font-bold text-[11px]">{item.temp}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default WeatherWidget;